import React, { Component } from "react";
import Header from "../../header/header";
import { Link } from "react-router-dom";
import Footer from "../footer";
import { BannerComoFunciona } from "../../header/banner";
import "./como_funciona.css";
import DadosConsultoria from "../../consultoria/dados_consultoria";

export default class ComoFunciona extends Component {
  render() {
    return (
      <div id="como-funciona-container">
        {/* <Header /> */}
        <BannerComoFunciona
          imagem={require("../../../imagens/banner_como_funciona.jpg")}
        />
        <div className="container-fluid categorias">
          <div className="col-md-13 start-now">
            <Link to="/" className="btn-comecar mb-4">
              Começar agora
            </Link>
            {/* <h4 className="titulo-principal"> Especialidades populares</h4> */}
            {/* <div className="col-md-12">
              <div className="row">
                <div className="col-md-3 categoria-box">
                  <p>
                    COVID-19 <br />{" "}
                  </p>
                  <Link to="/" className="btn-custom-orange">
                    {" "}
                    Encontre Consultores
                  </Link>
                </div>
                <div className="col-md-3 categoria-box">
                  <p>
                    Consultores de <br /> Concurso
                  </p>
                  <Link to="/" className="btn-custom-orange">
                    {" "}
                    Encontre Consultores
                  </Link>
                </div>
                <div className="col-md-3 categoria-box">
                  <p>Consultores de Pequenas Empresas</p>
                  <Link to="/" className="btn-custom-orange">
                    {" "}
                    Encontre Consultores
                  </Link>
                </div>
                <div className="col-md-3">
                  <p>
                    Consultores de <br /> Nutrição
                  </p>
                  <Link to="/" className="btn-custom-orange">
                    {" "}
                    Encontre Consultores
                  </Link>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <div className="col-md-13 texto">
          <h1>
            <span> Como Funciona </span>
          </h1>
          <p className="subtitulo">É simples, fácil e seguro</p>
          <div className="col-md-12 texto-sobre mb-0">
            <p>
              Aqui no <span>Consulta ZAP</span>, nós ajudamos os pacientes a
              encontrarem <span>médicos de alta qualidade </span>
              para prover um atendimento personalizado de maneira rápida e
              remota.
            </p>
            <p>
              Buscamos facilitar essa conexão através de atendimentos gratuitos
              por chat ou videochamada de forma{" "}
              <span>simples, segura e eficaz</span>.
            </p>
            <p>
              {" "}
              <span>Cadastre-se agora</span> e experimente nossos serviços.
            </p>
          </div>
          {/* <a className="btn-custom-orange credito">Compre Créditos</a> */}
        </div>
        <DadosConsultoria component={1} />
        <Footer />
      </div>
    );
  }
}
